// src/utils/authUtils.js

export const getAuthToken = () => {
  try {
    const localStorageData = JSON.parse(localStorage.getItem("loginDetails"));
    return localStorageData?.token || null;
  } catch (error) {
    console.error("Error parsing token from localStorage", error);
    return null;
  }
};

export const handleUnauthorizedError = () => {
  localStorage.removeItem("loginDetails");
  localStorage.removeItem("isAuthenticated");
  localStorage.removeItem("microsoftLogin");
  localStorage.removeItem("user_email");
  window.location.href = "./";
};
